// Set session storage for floating cta
const floatingCTA = document.querySelector('.floating-cta')

if (!sessionStorage.getItem('floating-cta')) {
    if (floatingCTA) {
        floatingCTA.classList.add('active', 'show')
    }
} else {
    if (floatingCTA) {
        floatingCTA.classList.add('show')
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (floatingCTA && floatingCTA.classList.contains('active')) {
        setTimeout(() => {
            floatingCTA.classList.remove('active')
            if (!sessionStorage.getItem('floating-cta')) {
                sessionStorage.setItem('floating-cta', 'closed')
                floatingCTA.classList.add('show')
            }
            floatingCTA.classList.remove('active')
        }, 5000)
    }
})

document.addEventListener('click', (e) => {
    if (e.target.closest('.floating-cta button')) {
        floatingCTA.classList.remove('active')
    }

    if (e.target.closest('.open-cta')) {
        if (!floatingCTA.classList.contains('active')) {
            floatingCTA.classList.add('active')
        }
    }
})

// Interact with the floating CTA using keyboard
document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && document.activeElement === floatingCTA) {
        if (!floatingCTA.classList.contains('active')) {
            floatingCTA.classList.add('active')
        }
    }
    if (e.key === 'Enter' && e.target.closest('.floating-cta button')) {
        floatingCTA.classList.remove('active')
    }
    if (e.key === 'Escape' && floatingCTA.classList.contains('active')) {
        floatingCTA.classList.remove('active')
    }
})

function checkScrollPosition() {
    if (!floatingCTA) return
    if (window.scrollY + window.innerHeight >= document.body.scrollHeight) {
        floatingCTA.classList.add('!bottom-24')
    } else {
        floatingCTA.classList.remove('!bottom-24')
    }
}

// Debounce function
function debounce(func, wait = 20, immediate = true) {
    let timeout
    return function () {
        const context = this,
            args = arguments
        const later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

window.addEventListener('scroll', debounce(checkScrollPosition, 100, false))
